/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";
import LatestRight from "../../assets/svg/LatestRight.svg";

const LatestVersion = (props) => {
  const { upgradePackageInfo, countdown } = props;

  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <main className="main-content">
        <div className="icon-container">
          <img
            src={SMSMagicSvg}
            alt="SMS-Magic Icon"
            className="icon"
            style={{ width: "180px", height: "131.5px" }}
          />
          <div
            className="dotted-line"
            style={{ borderTop: "2px dotted #408B56" }}
          />
          <div>
            <img src={LatestRight} alt={"hand"} className={"hand"} />
          </div>
          <div
            className="dotted-line"
            style={{ borderTop: "2px dotted #408B56" }}
          />
          <div className="salesforce-logo-container">
            <img
              src={SalesforceImg}
              alt="Salesforce Logo"
              className="salesforce-logo"
              style={{ width: "180px", height: "126.75px" }}
            />
          </div>
        </div>

        <div className="installation-text-hero">
          <h1 className="title">
            You're on the Latest Version – SMS Magic{" "}
            {upgradePackageInfo?.package_installed}
          </h1>
          <p className="subtitle-magic">
            You already have the latest SMS Magic package installed. Continue to
            start using it.
          </p>
        </div>

        {countdown !== null && (
          <div
            className="workspace-redirect"
            style={{ marginBottom: "0px", marginTop: "0px" }}
          >
            Redirecting to workspace in{" "}
            <span className="timer">{countdown} seconds</span>
          </div>
        )}
      </main>
    </div>
  );
};

export default LatestVersion;
